export default function getYearCount() {
	return new Date().getFullYear() - 2006;
}
